/**
 * Khas FAQ Page JavaScript
 * Handles accordion functionality and search filtering
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize FAQ accordions
  initFAQAccordions();
  
  // Initialize FAQ search
  initFAQSearch();
});

/**
 * Initialize FAQ accordion functionality
 */
function initFAQAccordions() {
  const accordions = document.querySelectorAll('.khas-faq-accordion');
  
  accordions.forEach(accordion => {
    const trigger = accordion.querySelector('.khas-faq-accordion-trigger');
    
    if (trigger) {
      trigger.addEventListener('click', function() {
        const isExpanded = accordion.getAttribute('aria-expanded') === 'true';
        
        // Close all other accordions in the same category
        const category = accordion.getAttribute('data-category');
        if (category) {
          const categoryAccordions = document.querySelectorAll(`.khas-faq-accordion[data-category="${category}"]`);
          categoryAccordions.forEach(otherAccordion => {
            if (otherAccordion !== accordion) {
              otherAccordion.setAttribute('aria-expanded', 'false');
            }
          });
        }
        
        // Toggle current accordion
        accordion.setAttribute('aria-expanded', !isExpanded);
      });
      
      // Keyboard accessibility
      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          trigger.click();
        }
      });
    }
  });
}

/**
 * Initialize FAQ search functionality
 */
function initFAQSearch() {
  const searchInput = document.getElementById('khasFaqSearch');
  
  if (searchInput) {
    searchInput.addEventListener('input', function() {
      const searchTerm = this.value.toLowerCase().trim();
      filterFAQs(searchTerm);
    });
  }
}

/**
 * Filter FAQs based on search term
 * @param {string} searchTerm - The search term to filter by
 */
function filterFAQs(searchTerm) {
  const accordions = document.querySelectorAll('.khas-faq-accordion');
  const categories = document.querySelectorAll('.khas-faq-category');
  
  accordions.forEach(accordion => {
    const title = accordion.querySelector('.khas-faq-accordion-title');
    const content = accordion.querySelector('.khas-faq-accordion-content');
    
    if (title && content) {
      const titleText = title.textContent.toLowerCase();
      const contentText = content.textContent.toLowerCase();
      
      const matchesSearch = titleText.includes(searchTerm) || contentText.includes(searchTerm);
      
      if (matchesSearch) {
        accordion.classList.remove('hidden');
      } else {
        accordion.classList.add('hidden');
      }
    }
  });
  
  // Hide empty categories
  categories.forEach(category => {
    const visibleAccordions = category.querySelectorAll('.khas-faq-accordion:not(.hidden)');
    const categoryHeading = category.querySelector('.khas-faq-category-heading');
    
    if (visibleAccordions.length === 0) {
      category.style.display = 'none';
    } else {
      category.style.display = 'block';
    }
  });
  
  // Show message if no results
  showNoResultsMessage();
}

/**
 * Show/hide no results message
 */
function showNoResultsMessage() {
  const visibleAccordions = document.querySelectorAll('.khas-faq-accordion:not(.hidden)');
  let noResultsMessage = document.getElementById('khasFaqNoResults');
  
  if (visibleAccordions.length === 0) {
    if (!noResultsMessage) {
      const content = document.querySelector('.khas-faq-content');
      if (content) {
        noResultsMessage = document.createElement('div');
        noResultsMessage.id = 'khasFaqNoResults';
        noResultsMessage.className = 'khas-faq-no-results';
        noResultsMessage.innerHTML = '<p>No FAQs found matching your search. Try different keywords or browse all categories above.</p>';
        content.appendChild(noResultsMessage);
      }
    }
    noResultsMessage.style.display = 'block';
  } else {
    if (noResultsMessage) {
      noResultsMessage.style.display = 'none';
    }
  }
}
